import { OptionsItemLiveData } from "../../types/types";
import { Card, CardRank, CardSuit } from "../card/Card";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { CardsManager } from "../managers/CardsManager";
import { OptionsItemKeys } from "../managers/LayoutDataManager";
import { VariationId } from "../screen/TableScreen";
import { TrumpSuit } from "../state/TableStateMachine";
import { CardSuitToTrumpSuit } from "./CardSuitToTrumpSuit";

export function GetCardsValue(
    cards: Card[], 
    trumpSuit: TrumpSuit, 
    variationId: VariationId = undefined, 
): number
{
    // console.log("GetCardsValue");

    let cardsValue: number = 0;
    cards.forEach(card=>{
        let cardValue: number = 0;
        const cardSuitAsTrumpSuit: TrumpSuit = CardSuitToTrumpSuit(card.suit);

        // if ALL_TRUMPS mode
        if (trumpSuit == TrumpSuit.ALLTRUMPS) {
            const atPoints258: OptionsItemLiveData = variationId == undefined ? null : OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.atPoints258, variationId);
            if (atPoints258 && atPoints258.value) {
                cardValue += CardsManager.cardRankToCardProps[card.rank].valueAllTrumps258;
            }
            else {
                cardValue += CardsManager.cardRankToCardProps[card.rank].valueAllTrumps;
            }
        }
        // if NO_TRUMPS mode
        else 
        if (trumpSuit == TrumpSuit.NOTRUMPS) {
            const ntPoints130: OptionsItemLiveData = variationId == undefined ? null : OptionsDataManager.GetItemDataByItemId(OptionsItemKeys.ntPoints130, variationId);
            if (ntPoints130 && ntPoints130.value) {
                cardValue += CardsManager.cardRankToCardProps[card.rank].valueNoTrumps130;
            }
            else {
                cardValue += CardsManager.cardRankToCardProps[card.rank].valueNoTrumps;
            }
        }
        else {
            // if card(s) suit is trump suit
            if (trumpSuit == cardSuitAsTrumpSuit) {
                cardValue += CardsManager.cardRankToCardProps[card.rank].valueTrump;
            }
            // if card(s) suit is other suit (not a trump suit)
            else {
                cardValue += CardsManager.cardRankToCardProps[card.rank].valueOther;
            }
        }
        // console.log(CardSuit[card.suit]+"-"+CardRank[card.rank]+ " value = "+cardValue);
        cardsValue += cardValue;
    });

    // console.log("> totalValue:", cardsValue);
    return cardsValue;
}